import styled from "styled-components";

export const TabsContainer = styled.div``;

export const TabsContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
